import { MetricsKind } from "../types";
import { metricsNumberFormatter } from "./metrics-number-formatter";
import { NumberFormat } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";

export interface MetricsValueFormatterOptions {
    kind: MetricsKind;
    numberFormat?: NumberFormat;
}

export const getMetricsValueFormatter = (options: MetricsValueFormatterOptions) => {
    return metricsNumberFormatter(options);
};
